import React from 'react'

const RewindIcon = ({
width = 24,
height = 24,
color = '#CCCCCC',
className = '',
...props
}) => {
return (
<svg
xmlns="http://www.w3.org/2000/svg"
width={width}
height={height}
viewBox="0 0 24 24"
fill="none"
className={className}
aria-hidden="true"
{...props}
> <path
     d="M12 22C10.75 22 9.57917 21.7625 8.4875 21.2875C7.39583 20.8125 6.44583 20.1708 5.6375 19.3625C4.82917 18.5542 4.1875 17.6042 3.7125 16.5125C3.2375 15.4208 3 14.25 3 13H5C5 14.95 5.67917 16.6042 7.0375 17.9625C8.39583 19.3208 10.05 20 12 20C13.95 20 15.6042 19.3208 16.9625 17.9625C18.3208 16.6042 19 14.95 19 13C19 11.05 18.3208 9.39583 16.9625 8.0375C15.6042 6.67917 13.95 6 12 6H11.85L13.4 7.55L12 9L8 5L12 1L13.4 2.45L11.85 4H12C13.25 4 14.4208 4.2375 15.5125 4.7125C16.6042 5.1875 17.5542 5.82917 18.3625 6.6375C19.1708 7.44583 19.8125 8.39583 20.2875 9.4875C20.7625 10.5792 21 11.75 21 13C21 14.25 20.7625 15.4208 20.2875 16.5125C19.8125 17.6042 19.1708 18.5542 18.3625 19.3625C17.5542 20.1708 16.6042 20.8125 15.5125 21.2875C14.4208 21.7625 13.25 22 12 22ZM9 16V11.5H7.5V10H10.5V16H9ZM12.5 16C12.2167 16 11.9792 15.9042 11.7875 15.7125C11.5958 15.5208 11.5 15.2833 11.5 15V11C11.5 10.7167 11.5958 10.4792 11.7875 10.2875C11.9792 10.0958 12.2167 10 12.5 10H14.5C14.7833 10 15.0208 10.0958 15.2125 10.2875C15.4042 10.4792 15.5 10.7167 15.5 11V15C15.5 15.2833 15.4042 15.5208 15.2125 15.7125C15.0208 15.9042 14.7833 16 14.5 16H12.5ZM13 14.5H14V11.5H13V14.5Z"
     fill={color}
   /> </svg>
)
}

export default RewindIcon
